export default __webpack_public_path__ + "static/media/b&a-woman1.58d45fe0.png";